import { metrics } from '@atlassian/browser-metrics';

export const deploymentsPageLoad = metrics.pageLoad({
	key: 'software.deployments',
	slo: {
		fmp: {
			initial: { threshold: 1000 },
			transition: { threshold: 1000 },
		},
		tti: {
			initial: { threshold: 4000 },
			transition: { threshold: 4000 },
		},
	},
});

/**
 * Fired when we have fetched 40 issues or all available issues
 */
export const deploymentsAndIssuePageAGSPageLoad = metrics.pageLoad({
	key: 'software.deployments.ags',
	slo: {
		fmp: {
			initial: { threshold: 1000 },
			transition: { threshold: 1000 },
		},
		tti: {
			initial: { threshold: 4000 },
			transition: { threshold: 4000 },
		},
	},
});
